import { mapActions, mapState, mapGetters } from "vuex"
import dayjs from 'dayjs';
import axios from 'axios';

export default {
	components: {},
	filters: {
		formatDate(value) {
			return dayjs(value).format('DD.MM.YYYY HH:mm:ss');
		}
	},
	computed: {
		...mapGetters({
			applications: 'getApplications'
		}),
		...mapState({
			total: (state) => state.Applications.total,
			loading: state => state.Applications.loading,
		})
	},
	data() {
		return {
			columns: [
				{
					label: 'Прізвище',
					prop: 'lastName'
				},
				{
					label: 'Ім\'я',
					prop: 'firstName'
				},
				{
					label: 'ЕІС-код',
					prop: 'eisCode'
				},
				{
					label: 'Статус',
					prop: 'status',
				},
				{
					label: 'Створено',
					prop: 'created',
				},
				{
					label: 'Оновлено',
					prop: 'updated',
				},
			],
			applicationStatuses: [
				{
					label: 'Нова',
					value: 'Нова'
				},
				{
					label: 'В роботі',
					value: 'В роботі'
				},
				{
					label: 'Опрацьована',
					value: 'Опрацьована'
				},
				{
					label: 'Закрита',
					value: 'Закрита'
				}
			],
			search: '',
			limit: 20,
			offset: 0,
			currentPage: 1,
		}
	},
	methods: {
		...mapActions(['getAllApplications', 'statusIsEdit']),
		hendleSearchClick() {
			this.getAllApplications({
				eisCode: this.search
			})
		},
		indexMethod(index) {
			if (this.currentPage === 1) {
				return index;
			}
			return index + this.offset;
		},
		downloadDocuments(application) {
			window.open(`api/application/download-documents?eisCode=${application.eisCode}`, '_blank');
		},
		onStatusChange({ status, _id }, index) {
			axios.post('api/application/change-status', {
				id: _id,
				status
			}).then(response => {
				this.$notify.success({
					title: 'Вітаємо!',
					message: response.data,
					duration: 2000,
				});
				this.statusIsEdit({
					index: index,
					value: false,
				});
			}, error => {
				console.log(error);

			})
		},
		onStatusClick(raw) {
			this.statusIsEdit({
				index: raw.$index,
				value: true,
			});
		}
	},
	watch: {
		currentPage(val) {
			this.offset = this.limit * val - this.limit;
			this.getAllApplications({ limit: this.limit, offset: this.offset });
		}
	},
	beforeMount() {
		this.getAllApplications({ limit: this.limit, offset: this.offset });
	}
}